import { BaseAssessment } from 'types/api';
import { GraphTabs } from 'components/GraphTabs';
import styles from './Mechanics.module.css';
import { useConfig } from './useConfig';
import { useLeftKneeData } from './useLeftKneeData';

interface Props {
  assessment: BaseAssessment;
  className?: string;
}

export const LeftKnee = (props: Props) => {
  const { assessment, className } = props;
  const data = useLeftKneeData([assessment]);
  const config = useConfig('Left Knee Mechanics', [assessment], data);
  return (
    <GraphTabs
      className={className}
      config={config}
      defaultTab="barTab"
      headerClassName={styles.header}
      heading="Left Knee Mechanics"
    />
  );
};
